/* eslint no-unused-vars: 0 */

/**
 * This file was automatically generated by ruby_to_typescript.rake.
 * Do not modify it by hand.
 */
export enum SegmentEventObject {
  COMPANY = "Company",
  INVITED_USER = "InvitedUser",
  MESSAGE = "Message",
  NOTIFICATION = "Notification",
  NOTIFICATION_SETTINGS = "NotificationSettings",
  PROPOSAL = "Proposal",
  PROPOSAL_DISCUSSION = "ProposalDiscussion",
  REQUEST = "Request",
  REQUEST_COMMENT = "RequestComment",
  REQUEST_FOR_STARTUP_PROPOSAL = "RequestForStartupProposal",
  REQUEST_FOR_EXPERT_PROPOSAL = "RequestForExpertProposal",
  USER = "User",
  USER_FOLLOWED_REQUEST = "UserFollowedRequest",
}
